// @ts-nocheck — generated mock data ported from the design prototype; real types land in Phase 3.
/* Boost Blenz — Admin Dashboard demo data
   Seeded so the dashboard is stable across reloads. Attaches to window.BBAdminData.
   This is mock data for a design prototype — every number is fabricated but plausible.
*/
export const BBAdminData: any = (function () {
  // --- tiny seeded PRNG (mulberry32) ---
  function mulberry32(a) {
    return function () {
      a |= 0; a = (a + 0x6D2B79F5) | 0;
      let t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  const rnd = mulberry32(20260613);
  const pick = (arr) => arr[Math.floor(rnd() * arr.length)];
  const between = (lo, hi) => lo + Math.floor(rnd() * (hi - lo + 1));

  const TODAY = new Date(2026, 5, 13); // Jun 13 2026
  function dateMinus(days) {
    const d = new Date(TODAY); d.setDate(d.getDate() - days); return d;
  }
  function fmt(d) {
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }
  function fmtFull(d) {
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  }
  function relTime(days) {
    if (days <= 0) return 'just now';
    const mins = Math.round(days * 24 * 60);
    if (mins < 60) return Math.max(1, mins) + 'm ago';
    const hours = Math.round(days * 24);
    if (hours < 24) return hours + 'h ago';
    const d = Math.round(days);
    if (d < 2) return 'yesterday';
    return d + 'd ago';
  }

  // ---------------- STAGES ----------------
  const STAGES = ['Liver', 'Kidney', 'Parasite', 'Metal'];
  const STAGE_LEN = { Liver: 14, Kidney: 14, Parasite: 30, Metal: 30 };
  const STAGE_COLOR = { Liver: '#f47f49', Kidney: '#246d7f', Parasite: '#ff5b4a', Metal: '#793a93', Completed: '#08a225', 'Not started': '#9a9a9a' };

  // ---------------- ROSTER ----------------
  const FIRST = ['Jordan', 'Maya', 'Devon', 'Priya', 'Marcus', 'Elena', 'Sam', 'Aaliyah', 'Tomás', 'Greta', 'Noah', 'Inez', 'Kai', 'Renee', 'Hassan', 'Brielle', 'Oscar', 'Lena', 'Wyatt', 'Sofia', 'Theo', 'Camille', 'Dom', 'Yara', 'Felix', 'Nadia', 'Carlos', 'Bea', 'Ivan', 'Mei', 'Otis', 'June', 'Rafe', 'Tessa', 'Hugo', 'Cleo', 'Beau', 'Dahlia', 'Cyrus', 'Faye'];
  const LAST = ['Taylor', 'Nguyen', 'Brooks', 'Patel', 'Reyes', 'Sokolov', 'Carter', 'Johnson', 'Vidal', 'Lindqvist', 'Bauer', 'Okafor', 'Tanaka', 'Flores', 'Amari', 'Coleman', 'Webb', 'Romano', 'Hale', 'Castillo', 'Mercer', 'Dubois', 'Foster', 'Haddad', 'Klein', 'Petrova', 'Mendez', 'Whitfield', 'Novak', 'Chen', 'Sullivan', 'Park', 'Greer', 'Lindholm', 'Costa', 'Bianchi', 'Ramsey', 'Singh', 'Abebe', 'Moreau'];
  const KITS = [
    { name: 'Full 4-Stage Kit', stages: ['Liver', 'Kidney', 'Parasite', 'Metal'], price: 129 },
    { name: 'Liver + Kidney', stages: ['Liver', 'Kidney'], price: 69 },
    { name: 'Parasite Killer', stages: ['Parasite'], price: 34.5 },
    { name: 'Liver Detox', stages: ['Liver'], price: 34.5 },
  ];

  function buildProtocolState(kit, daysSinceStart) {
    // walk through the kit stages; each stage = STAGE_LEN days, no breaks
    let remaining = daysSinceStart;
    let total = kit.stages.reduce((s, st) => s + STAGE_LEN[st], 0);
    for (const st of kit.stages) {
      const len = STAGE_LEN[st];
      if (remaining < len) {
        return { stage: st, dayInStage: remaining + 1, stageLen: len, totalDay: daysSinceStart + 1, totalLen: total, done: false };
      }
      remaining -= len;
    }
    return { stage: 'Completed', dayInStage: 0, stageLen: 0, totalDay: total, totalLen: total, done: true };
  }

  const customers = [];

  // Featured: Jordan Taylor (matches prototype demo state)
  (function () {
    const kit = KITS[0];
    const start = new Date(2026, 4, 6); // May 6
    const daysSince = Math.round((TODAY - start) / 86400000); // 38
    const ps = buildProtocolState(kit, daysSince - 1); // day 38 -> Parasite day 10
    customers.push({
      id: 'C-1047', name: 'Jordan Taylor', email: 'jordan.taylor@gmail.com',
      orderNo: '1047', kit: kit.name, kitStages: kit.stages, price: kit.price,
      startDate: start, started: true, shopifyLinked: true,
      stage: ps.stage, dayInStage: ps.dayInStage, stageLen: ps.stageLen,
      totalDay: ps.totalDay, totalLen: ps.totalLen,
      adherence: 92, missedDays: 1, lastActiveDays: 0.3,
      notif: { morning: true, binder: true, content: true, marketing: false },
      suppressed: [], status: 'active', featured: true,
      city: 'Austin, TX', orders: 3, ltv: 287,
    });
  })();

  const STATUS_MIX = ['active', 'active', 'active', 'active', 'idle', 'idle', 'completed', 'never-started', 'never-started'];
  for (let i = 0; i < 58; i++) {
    const first = FIRST[(i + 1) % FIRST.length];
    const last = LAST[(i * 7 + 3) % LAST.length];
    const kit = pick(KITS);
    const status = STATUS_MIX[i % STATUS_MIX.length];
    const orderNo = String(1048 + i);
    let started = status !== 'never-started';
    let daysSince = started ? between(1, kit.stages.reduce((s, st) => s + STAGE_LEN[st], 0) + (status === 'completed' ? between(10, 50) : 0)) : 0;
    const start = dateMinus(daysSince + between(0, 4));
    let ps = started ? buildProtocolState(kit, Math.min(daysSince - 1, kit.stages.reduce((s, st) => s + STAGE_LEN[st], 0) - 1 + (status === 'completed' ? 60 : 0))) : null;
    if (status === 'completed') ps = { stage: 'Completed', dayInStage: 0, stageLen: 0, totalDay: kit.stages.reduce((s, st) => s + STAGE_LEN[st], 0), totalLen: kit.stages.reduce((s, st) => s + STAGE_LEN[st], 0), done: true };
    const adherence = status === 'never-started' ? 0 : status === 'idle' ? between(38, 66) : between(70, 99);
    const lastActiveDays = status === 'never-started' ? between(3, 22) : status === 'idle' ? between(3, 9) + rnd() : rnd() * 2;
    // completed + break-over => upsell ready
    const breakOverDays = status === 'completed' ? between(20, 45) : 0;
    customers.push({
      id: 'C-' + orderNo, name: first + ' ' + last,
      email: (first + '.' + last).toLowerCase().replace(/[^a-z.]/g, '') + '@' + pick(['gmail.com', 'gmail.com', 'icloud.com', 'yahoo.com', 'outlook.com']),
      orderNo, kit: kit.name, kitStages: kit.stages, price: kit.price,
      startDate: started ? start : null, started, shopifyLinked: rnd() > 0.06,
      stage: started ? ps.stage : 'Not started', dayInStage: started ? ps.dayInStage : 0,
      stageLen: started ? ps.stageLen : 0, totalDay: started ? ps.totalDay : 0,
      totalLen: started ? ps.totalLen : kit.stages.reduce((s, st) => s + STAGE_LEN[st], 0),
      adherence, missedDays: status === 'never-started' ? 0 : between(0, 6),
      lastActiveDays, notif: {
        morning: rnd() > 0.08, binder: rnd() > 0.12, content: rnd() > 0.3, marketing: rnd() > 0.55,
      },
      suppressed: rnd() > 0.9 ? [pick(['marketing', 'content'])] : [],
      status, breakOverDays,
      upsellReady: status === 'completed' && breakOverDays >= 30,
      city: pick(['Austin, TX', 'Denver, CO', 'Portland, OR', 'Miami, FL', 'Chicago, IL', 'Seattle, WA', 'Phoenix, AZ', 'Nashville, TN', 'Boston, MA', 'Sacramento, CA']),
      orders: between(1, 4), ltv: between(34, 420),
    });
  }

  // ---------------- AGGREGATES ----------------
  const totalCustomers = customers.length;
  const activeProtocols = customers.filter((c) => c.status === 'active').length;
  const idleCount = customers.filter((c) => c.status === 'idle').length;
  const neverStarted = customers.filter((c) => c.status === 'never-started').length;
  const completedCount = customers.filter((c) => c.status === 'completed').length;
  const upsellReady = customers.filter((c) => c.upsellReady).length;
  const avgAdherence = Math.round(customers.filter((c) => c.started).reduce((s, c) => s + c.adherence, 0) / customers.filter((c) => c.started).length);
  const stageBreakdown = ['Liver', 'Kidney', 'Parasite', 'Metal', 'Completed', 'Not started'].map((st) => ({
    stage: st, count: customers.filter((c) => c.stage === st).length, color: STAGE_COLOR[st],
  }));

  // ---------------- TIME SERIES (30 days) ----------------
  function series(base, jitter, trend) {
    const out = [];
    for (let i = 29; i >= 0; i--) {
      const t = (29 - i) / 29;
      const v = Math.max(0, Math.round(base + trend * t * base + (rnd() - 0.5) * jitter));
      out.push({ date: fmt(dateMinus(i)), value: v });
    }
    return out;
  }
  const dau = series(180, 36, 0.5); // growing
  dau[dau.length - 1].value = 247;  // today
  const pushDelivery = []; // delivered % each day
  for (let i = 29; i >= 0; i--) {
    const sent = between(120, 260);
    // one bad day 1 day ago (incident)
    let rate = 0.965 + (rnd() - 0.5) * 0.02;
    if (i === 1) rate = 0.71;
    const delivered = Math.round(sent * rate);
    pushDelivery.push({ date: fmt(dateMinus(i)), sent, delivered, failed: sent - delivered, rate: Math.round(rate * 1000) / 10 });
  }
  const webhooks = [];
  for (let i = 29; i >= 0; i--) {
    const received = between(8, 34);
    let failed = rnd() > 0.8 ? between(0, 2) : 0;
    if (i === 0) failed = 23; // today's incident
    if (i === 1) failed = 4;
    webhooks.push({ date: fmt(dateMinus(i)), received, attached: received - failed, failed });
  }

  // ---------------- SYSTEM SERVICES ----------------
  const services = [
    { name: 'Shopify Customer Account API', status: 'operational', latency: '212ms', detail: 'OAuth login + order reads' },
    { name: 'Shopify Order Webhooks', status: 'degraded', latency: '1.8s', detail: 'orders/create — elevated failures' },
    { name: 'Push service (FCM / APNs)', status: 'operational', latency: '340ms', detail: 'Web push + iOS PWA' },
    { name: 'App database', status: 'operational', latency: '24ms', detail: 'Protocol states + logs' },
    { name: 'Auth / session', status: 'operational', latency: '88ms', detail: 'Token refresh' },
    { name: 'Articles RSS sync', status: 'operational', latency: '—', detail: 'Last sync 41m ago' },
  ];

  // ---------------- INCIDENTS (Claude-diagnosed) ----------------
  const incidents = [
    {
      id: 'INC-204', severity: 'critical', open: true,
      title: 'Order webhooks failing — 23 orders not attached',
      metric: 'orders/create webhook', when: relTime(0.1),
      summary: '23 of 31 order webhooks in the last 2h returned 401 from our endpoint. New customers can log in but see no orders to track.',
      claudeCause: 'The Shopify webhook HMAC secret was rotated in the Shopify admin yesterday but the app backend still holds the previous secret, so signature verification rejects every delivery as unauthorized. This matches the failure starting right after the 5:40 PM config change and affecting 100% of new deliveries.',
      claudeFix: 'Update SHOPIFY_WEBHOOK_SECRET to the current value and replay the 23 failed deliveries from Shopify\'s webhook log. I can re-queue the 23 held events once the secret is corrected.',
      fixLabel: 'Re-queue 23 failed webhooks',
      impact: '23 customers · 8 with active kits',
      confidence: 94,
    },
    {
      id: 'INC-203', severity: 'warning', open: true,
      title: 'Push delivery dipped to 71% yesterday',
      metric: 'push delivery rate', when: relTime(1),
      summary: 'Delivery rate fell from ~96% to 71% for ~5 hours yesterday evening, then recovered on its own.',
      claudeCause: 'The dip is isolated to iOS PWA tokens and lines up with an APNs partial outage Apple reported in the same window. Android (FCM) delivery stayed at 97%. No code or config change on our side.',
      claudeFix: 'No action needed — this resolved when APNs recovered. The 38 morning-dose reminders that failed were retried automatically and delivered. I\'ll keep watching iOS delivery and re-flag if it drops again.',
      fixLabel: 'Mark resolved · keep watching',
      impact: '38 reminders delayed, all retried',
      confidence: 88,
    },
    {
      id: 'INC-201', severity: 'resolved', open: false,
      title: 'RSS article sync stalled',
      metric: 'Articles RSS', when: relTime(4),
      summary: 'Article feed stopped syncing for 9 hours; new blog post did not appear in-app.',
      claudeCause: 'The blog feed URL started 302-redirecting to an https variant our fetcher didn\'t follow.',
      claudeFix: 'Updated the feed URL to the canonical https endpoint and backfilled the missed post. Sync is healthy.',
      fixLabel: 'Resolved',
      impact: '1 post delayed 9h',
      confidence: 91,
    },
  ];

  // ---------------- CLAUDE ANOMALY FLAGS (auto, top of dash) ----------------
  const anomalies = [
    {
      id: 'A1', severity: 'critical', text: 'Webhook failure rate is 4.2× the 30-day baseline in the last 2 hours.',
      link: 'INC-204',
    },
    {
      id: 'A2', severity: 'info', text: '6 customers hit "completed + break over" this week — your largest upsell window yet.',
      link: 'upsell',
    },
    {
      id: 'A3', severity: 'info', text: 'Found 3 opt-out requests in email and auto-suppressed them — review the new suppressions.',
      link: 'suppression',
    },
  ];

  // ---------------- CONTENT ----------------
  const content = {
    books: [
      { id: 'BK1', title: 'Food As A Weapon — Book 1', type: 'Book', status: 'published', date: fmtFull(dateMinus(60)), alert: true, reads: 412 },
      { id: 'BK2', title: 'How To Live Parasite Free in 30 Days', type: 'Book', status: 'published', date: fmtFull(dateMinus(120)), alert: true, reads: 988 },
      { id: 'BK3', title: 'The Binder — Activated Charcoal Guide', type: 'Book', status: 'draft', date: '—', alert: true, reads: 0 },
    ],
    articles: [
      { id: 'AR1', title: 'Why binders go on empty stomachs', type: 'Article', status: 'published', date: fmtFull(dateMinus(2)), alert: true, reads: 176 },
      { id: 'AR2', title: 'Reading your detox: what\'s normal', type: 'Article', status: 'published', date: fmtFull(dateMinus(11)), alert: false, reads: 240 },
      { id: 'AR3', title: 'Heavy Metal stage — what to expect', type: 'Article', status: 'scheduled', date: fmtFull(dateMinus(-3)), alert: true, reads: 0 },
    ],
  };

  // ---------------- PUSH SEGMENTS + HISTORY ----------------
  const segments = [
    { id: 'seg-upsell', name: 'Completed + break over', count: upsellReady, desc: 'Finished a protocol, 1-month break elapsed' },
    { id: 'seg-never', name: 'Never started', count: neverStarted, desc: 'Order delivered, tracker not begun' },
    { id: 'seg-idle', name: 'Idle 3+ days', count: idleCount, desc: 'Was tracking, no activity recently' },
    { id: 'seg-parasite', name: 'Parasite stage, day 7+', count: customers.filter((c) => c.stage === 'Parasite' && c.dayInStage >= 7).length, desc: 'Mid-parasite, candidates for binder reminders' },
    { id: 'seg-all', name: 'All active trackers', count: activeProtocols, desc: 'Everyone currently mid-protocol' },
  ];
  const pushHistory = [
    { id: 'P1', title: 'Your break is over — ready for round 2?', segment: 'Completed + break over', channel: 'both', sent: 5, delivered: 5, opened: 4, when: relTime(2) },
    { id: 'P2', title: 'New article: Why binders go on empty stomachs', segment: 'All active trackers', channel: 'both', sent: 31, delivered: 30, opened: 19, when: relTime(2) },
    { id: 'P3', title: 'Don\'t forget Day 1 — your kit is waiting', segment: 'Never started', channel: 'push', sent: 9, delivered: 8, opened: 3, when: relTime(6) },
  ];

  // ---------------- SUPPRESSION ----------------
  const suppressionLists = [
    { id: 'marketing', name: 'Marketing / upsell', count: customers.filter((c) => c.suppressed.includes('marketing')).length },
    { id: 'content', name: 'New content alerts', count: customers.filter((c) => c.suppressed.includes('content')).length },
    { id: 'reminders', name: 'Protocol reminders', count: 0 },
  ];

  // ---------------- FULL DAILY SERIES (Jan 1 → today) for range filters ----------------
  const YEAR_START = new Date(2026, 0, 1);
  const NDAYS = Math.round((TODAY - YEAR_START) / 86400000) + 1; // 164 (Jun 13 is a Saturday)
  function addDays(dt, n) { const x = new Date(dt); x.setDate(x.getDate() + n); return x; }

  // App upsell catalog — items the app can attribute a Shopify sale to (re-orders + add-ons)
  const UPSELL_SKUS = [
    { sku: 'KIT-4STAGE', name: 'Full 4-Stage Kit', price: 129, w: 5 },
    { sku: 'PARA-KILL', name: 'Parasite Killer', price: 34.5, w: 9 },
    { sku: 'BINDER-AC', name: 'The Binder · Activated Charcoal', price: 24, w: 7 },
    { sku: 'LIV-DETOX', name: 'Liver Detox', price: 34.5, w: 5 },
    { sku: 'LIV-KID', name: 'Liver + Kidney', price: 69, w: 4 },
    { sku: 'EBOOK-PF', name: 'Parasite Free · eBook', price: 19, w: 6 },
  ];
  const skuTotalW = UPSELL_SKUS.reduce((s, k) => s + k.w, 0);
  function pickSku() { let r = rnd() * skuTotalW; for (const k of UPSELL_SKUS) { if ((r -= k.w) <= 0) return k; } return UPSELL_SKUS[0]; }

  const daily = [];
  for (let i = 0; i < NDAYS; i++) {
    const date = addDays(YEAR_START, i);
    const tt = i / (NDAYS - 1);
    const dow = date.getDay();
    const weekend = (dow === 0 || dow === 6) ? 0.93 : 1;
    const dauV = Math.max(40, Math.round((120 + 130 * tt) * weekend + (rnd() - 0.5) * 30));
    const onboarded = Math.max(0, Math.round(1.4 + 2.4 * tt + (rnd() - 0.5) * 3));
    const sent = between(120, 260);
    let rate = 0.965 + (rnd() - 0.5) * 0.02;
    if (i === NDAYS - 2) rate = 0.71; // iOS dip yesterday (INC-203)
    const delivered = Math.round(sent * rate);
    let whFailed = rnd() > 0.82 ? between(0, 2) : 0;
    if (i === NDAYS - 1) whFailed = 23; // today's incident
    if (i === NDAYS - 2) whFailed = 4;
    // in-app attributed upsell orders (app push/email → Shopify sale)
    const orderCount = Math.max(0, Math.round((0.6 + 2.6 * tt) + (rnd() - 0.5) * 2.2));
    const orders = [];
    for (let o = 0; o < orderCount; o++) {
      const k = pickSku();
      const qty = rnd() > 0.86 ? 2 : 1;
      orders.push({ sku: k.sku, name: k.name, qty, revenue: +(k.price * qty).toFixed(2), source: rnd() > 0.5 ? 'push' : 'email' });
    }
    const revenue = +orders.reduce((s, o) => s + o.revenue, 0).toFixed(2);
    daily.push({ date, lbl: fmt(date), dau: dauV, onboarded, sent, delivered, rate: Math.round(rate * 1000) / 10, whFailed, orders, conversions: orders.length, revenue });
  }
  daily[NDAYS - 1].dau = 247; // pin today

  // ---------------- DATE RANGES ----------------
  const RANGES = [
    { id: 'today', label: 'Today' }, { id: 'wtd', label: 'WTD' }, { id: 'mtd', label: 'MTD' },
    { id: 'l30', label: 'L30' }, { id: 'l60', label: 'L60' }, { id: 'l90', label: 'L90' }, { id: 'ytd', label: 'YTD' },
  ];
  const RANGE_LONG = { today: 'Today', wtd: 'Week to date', mtd: 'Month to date', l30: 'Last 30 days', l60: 'Last 60 days', l90: 'Last 90 days', ytd: 'Year to date' };
  function rangeStart(id) {
    if (id === 'wtd') return addDays(TODAY, -TODAY.getDay());           // back to Sunday
    if (id === 'mtd') return new Date(TODAY.getFullYear(), TODAY.getMonth(), 1);
    if (id === 'l30') return addDays(TODAY, -29);
    if (id === 'l60') return addDays(TODAY, -59);
    if (id === 'l90') return addDays(TODAY, -89);
    if (id === 'ytd') return new Date(TODAY.getFullYear(), 0, 1);
    return new Date(TODAY);                                              // today
  }
  function rangeLabel(id) { return RANGE_LONG[id] || id; }
  function sliceDaily(id) { const s = rangeStart(id); s.setHours(0, 0, 0, 0); return daily.filter((d) => d.date >= s); }
  function rangeStats(id) {
    const rows = sliceDaily(id);
    const dauAvg = Math.round(rows.reduce((s, r) => s + r.dau, 0) / rows.length);
    const dauPeak = Math.max(...rows.map((r) => r.dau));
    const onboarded = rows.reduce((s, r) => s + r.onboarded, 0);
    const sent = rows.reduce((s, r) => s + r.sent, 0);
    const delivered = rows.reduce((s, r) => s + r.delivered, 0);
    const rateAvg = sent ? Math.round((delivered / sent) * 1000) / 10 : 0;
    const conversions = rows.reduce((s, r) => s + r.conversions, 0);
    const revenue = +rows.reduce((s, r) => s + r.revenue, 0).toFixed(2);
    const skuMap = {}; let pushRev = 0, emailRev = 0, pushConv = 0, emailConv = 0;
    rows.forEach((r) => r.orders.forEach((o) => {
      if (!skuMap[o.sku]) skuMap[o.sku] = { sku: o.sku, name: o.name, qty: 0, revenue: 0, orders: 0 };
      skuMap[o.sku].qty += o.qty; skuMap[o.sku].revenue += o.revenue; skuMap[o.sku].orders += 1;
      if (o.source === 'push') { pushRev += o.revenue; pushConv += 1; } else { emailRev += o.revenue; emailConv += 1; }
    }));
    const skus = Object.values(skuMap).map((s) => ({ ...s, revenue: +s.revenue.toFixed(2) })).sort((a, b) => b.revenue - a.revenue);
    const aov = conversions ? Math.round(revenue / conversions) : 0;
    return { rows, dauToday: rows[rows.length - 1].dau, dauAvg, dauPeak, onboarded, sent, delivered, rateAvg, conversions, revenue, skus, pushRev: +pushRev.toFixed(2), emailRev: +emailRev.toFixed(2), pushConv, emailConv, aov };
  }

  // ---------------- PERIOD-OVER-PERIOD COMPARISON ----------------
  // The previous window of equal length immediately preceding the selected range,
  // so a delta is always "true to the comparison": today vs yesterday, WTD vs the
  // prior week-to-date, MTD vs the prior month-to-date, L30 vs the 30 days before, etc.
  function prevSlice(id) {
    const cur = sliceDaily(id);
    if (!cur.length) return [];
    const firstIdx = daily.indexOf(cur[0]);
    const n = cur.length;
    return daily.slice(Math.max(0, firstIdx - n), firstIdx);
  }
  function periodDelta(id, key, mode) {
    const cur = sliceDaily(id), prev = prevSlice(id);
    if (!prev.length || !cur.length) return null;
    const agg = (rows) => {
      const arr = rows.map((r) => r[key] || 0);
      const sum = arr.reduce((a, b) => a + b, 0);
      return mode === 'avg' ? sum / arr.length : sum;
    };
    const a = agg(prev), b = agg(cur);
    if (!a) return null;
    return Math.round(((b - a) / a) * 100);
  }
  // human label for what the current range is being compared against
  const COMPARE_LABEL = {
    today: 'vs yesterday', wtd: 'vs last week', mtd: 'vs last month',
    l30: 'vs prior 30d', l60: 'vs prior 60d', l90: 'vs prior 90d', ytd: 'vs prior period',
  };

  // ---------------- NOTIFICATION CATEGORIES ----------------
  // The keys here are the per-customer notif/opt-in flags; "name" explains each suppression tag.
  const notifCategories = [
    { key: 'morning', name: 'Morning reminders', short: 'Morning', desc: 'Daily nudge to take the morning dose', auto: true },
    { key: 'binder', name: 'Binder reminders', short: 'Binder', desc: 'Fires when the binder window opens (≈2h after meals)', auto: true },
    { key: 'content', name: 'Content reminders', short: 'Content', desc: 'New article or book published', auto: true },
    { key: 'marketing', name: 'Marketing reminders', short: 'Marketing', desc: 'Re-order prompts and offers', auto: false },
  ];

  // ---------------- AUTOMATIONS (behavior-triggered, fire automatically) ----------------
  const automations = [
    { id: 'au-break', name: 'Break is over — re-order', trigger: 'Protocol completed + 30-day break elapsed', channel: 'both', on: true, audience: 'Completed + break over', sent30: 11, conv: 4, rev: 612 },
    { id: 'au-never', name: 'Never-started nudge', trigger: 'Order delivered, tracker not begun within 3 days', channel: 'push', on: true, audience: 'Never started', sent30: 18, conv: 5, rev: 173 },
    { id: 'au-idle', name: 'Idle recovery', trigger: 'Mid-protocol, no app activity for 3 days', channel: 'push', on: true, audience: 'Idle 3+ days', sent30: 26, conv: 2, rev: 49 },
    { id: 'au-binder', name: 'Binder window reminder', trigger: 'Parasite stage — binder window opens', channel: 'push', on: true, audience: 'Parasite stage, day 7+', sent30: 142, conv: 0, rev: 0 },
    { id: 'au-content', name: 'New content alert', trigger: 'Article or book published in Shopify', channel: 'both', on: true, audience: 'All active trackers', sent30: 2, conv: 3, rev: 91 },
    { id: 'au-restock', name: 'Low-supply re-order', trigger: 'Projected to run out of binder within 5 days', channel: 'both', on: false, audience: 'Active, supply < 5 days', sent30: 0, conv: 0, rev: 0 },
  ];

  // ---------------- EMAIL OPT-OUT SCAN (Claude reads inbound mail, auto-suppresses) ----------------
  const emailOptOuts = [
    { id: 'EO1', name: 'Greta Lindqvist', email: 'greta.lindqvist@gmail.com', category: 'marketing', excerpt: 'please stop sending me the re-order emails, not interested right now', when: relTime(0.25), action: 'auto-suppressed' },
    { id: 'EO2', name: 'Marcus Carter', email: 'marcus.carter@icloud.com', category: 'all', excerpt: 'unsubscribe me from all the app notifications please', when: relTime(0.9), action: 'auto-suppressed' },
    { id: 'EO3', name: 'Inez Okafor', email: 'inez.okafor@yahoo.com', category: 'content', excerpt: "don't want the new-article alerts anymore, too many", when: relTime(2.1), action: 'auto-suppressed' },
  ];

  // ---------------- KPI CARDS ----------------
  function delta(arr) {
    const a = arr[arr.length - 8].value, b = arr[arr.length - 1].value;
    return Math.round(((b - a) / a) * 100);
  }
  const todayPush = pushDelivery[pushDelivery.length - 1];
  const todayWebhook = webhooks[webhooks.length - 1];
  const weekWebhookFailed = webhooks.slice(-7).reduce((s, w) => s + w.failed, 0);

  return {
    TODAY, fmt, fmtFull, relTime, STAGE_COLOR, STAGE_LEN,
    customers, jordan: customers[0],
    aggregates: { totalCustomers, activeProtocols, idleCount, neverStarted, completedCount, upsellReady, avgAdherence, stageBreakdown },
    series: { dau, pushDelivery, webhooks },
    daily, RANGES, RANGE_LONG, rangeStart, rangeLabel, sliceDaily, rangeStats, prevSlice, periodDelta, COMPARE_LABEL,
    UPSELL_SKUS, automations, emailOptOuts, notifCategories,
    sparkDelta: { dau: delta(dau) },
    services, incidents, anomalies, content, segments, pushHistory, suppressionLists,
    health: {
      dauToday: dau[dau.length - 1].value,
      pushRate: todayPush.rate,
      pushFailedToday: todayPush.failed,
      webhookFailedToday: todayWebhook.failed,
      webhookSuccessRate: Math.round(((todayWebhook.received - todayWebhook.failed) / Math.max(1, todayWebhook.received)) * 1000) / 10,
      weekWebhookFailed,
      newThisWeek: 14,
      openIncidents: incidents.filter((i) => i.open).length,
    },
  };
})();